export { MailIcon } from './mail'
